"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isValidEmail() {
  var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!email) return new classes_1.ValidationResult(true);
  var regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var noMatchSpecialChars = !email.match(/[~!#$%^&*()+=`{}[\]|\\:;'<>,?]/gi);
  var invalidEmailMessage = 'Email inválido';
  if (email.indexOf('@-') > 0) {
    return new classes_1.ValidationResult(false, invalidEmailMessage);
  }
  var isValid = regExp.test(email) && noMatchSpecialChars;
  var message = isValid ? '' : invalidEmailMessage;
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isValidEmail);